import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  rowData: [],
  currentBusinessCard: null
}

const contactsReducer = createReducer(initialState, {
  [ACT.CONTACT_DETAIL_FETCH_SUCCESS](state, action) {
    const { contact } = action.payload
    return {
      ...state,
      currentBusinessCard: contact
    }
  },
  [ACT.CONTACTS_ROW_DATA_FETCH_SUCCESS](state, action) {
    const { rowData } = action.payload
    return {
      ...state,
      rowData
    }
  },
  [ACT.CONTACTS_DETAIL_UPDATE_SUCCESS](state, action) {
    const { contact } = action.payload
    const index = state.rowData.findIndex(e => e.id === contact.id)
    return update(state, {
      rowData: {
        [index]: { $set: contact }
      }
    })
  },
  [ACT.CONTACTS_EMPLOYEES_FETCH_SUCCESS](state, action) {
    const { employees } = action.payload
    return {
      ...state,
      employees
    }
  },
  [ACT.CONTACT_CREATE_SUCCESS](state, action) {
    const { contact } = action.payload
    return update(state, {
      rowData: { $push: [contact] }
    })
  }
})

export default contactsReducer
